import { render, staticRenderFns } from "./ProfileModerateReveals.vue?vue&type=template&id=a58deae8&"
import script from "./ProfileModerateReveals.vue?vue&type=script&lang=js&"
export * from "./ProfileModerateReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports